import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import { post, fetch, Del, put } from "../../../../ask/axios";
import { downloadFile, fileSteamDownload } from '@/utils/download'
import shareOrder from "@/components/userCenter/public/shareOrder";
export default {
  components: { menberMenu, shareOrder },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      titNames: "Express shipment,Details",
      titUrls: "/exp/expList,",

      // titNames: "Account balance,Recharge",
      // titUrls: "/payment/myAccount,",

      //tab选项卡
      activeName: 'first',
      addSendBox: false,
      showModal: false,
      RemarksMesg: '分享备注',
      EmailMesg: '邮箱号码',

      //分享订单备注
      Remarks: '',
      //分享订单邮箱
      EmailId: '',

      //轨迹图片Url
      TrajectoryUrl: '',

      //订单信息
      OrderInfo: {
        BaseModeCode: '',
      },
      //订单仓库编号
      WareHouseID: '',
      //订单保险信息
      OredrInsurance: {
        BuyAmount: '',
        Beneficiary: '',
        IDCard: '',
        BenefitType: null,
        IsNeedVoucher: false
      },

      ProductList: [], //产品信息列表
      isShowProInfo: false,

      //订单收货材积信息
      OrderGoodsInfo: [],

      //收货材积
      Receivinginfo: {
        ReceCount: '', //件数
        ReceWeight: '',//实重
        ReceVolume: '',//总体积
        ReceCusVolWeight: '',//体积重
        ReceCusChargeWeight: '', //计费重
      },

      //订单附件信息
      OrderEnclosure: [],
      //订单账单信息
      OrderBillInfo: [],
      //订单轨迹信息
      ExpOrderTrackInfo: [],
      //仓库地址信息
      shipAddress: '',
      //收货人名称
      recipient: '',
      //收货电话
      phoneNum: '',
      //收货仓库名称
      WarehouseName: '',
      WareShortCode: '',

      //是否显示起运地信息
      IsDeparture: false,
      IsDeparture2: false,
      //是否显示仓库信息
      IsWareHouse: false,
      //是否显示目的地信息
      IsDestination: false,
      //是否提供仓库信息下拉
      IsWareHousexl: true,
      //是否提供目的地下拉
      IsDestinationxl: true,
      isCol: false,
      Token: '',

      CustomerID: '',
      CustomerIDUp: '',
      AmountName: '',

      OrderBillInfoBalan: [],

      //附加服务
      ExpOrderExtraFee: '',
      ExpOrderExtraFeeName: '',

      IsrefNo: false,


      //是否显示参考号添加框
      IsCustomerID: false,
      //是否显示货物详情
      IsOrderEnclosure: false,
      //是否显示仓库信息
      IsWarehouse: false,
      // 显示产品详情
      ShowProBox: true,

      // 费用展示
      Bill: {
        topShow: [],
        botShow: [],
        isHaveRMB: false, isHaveUSD: false, isHaveHK: false, isHaveEUR: false,
        topUnpayCny: 0, topUnpayUSD: 0, topUnpayHK: 0, topUnpayEUR: 0, //未支付
        botUnpayCny: 0, botUnpayUSD: 0, botUnpayHK: 0, botUnpayEUR: 0, //未支付
        topSumCNY: 0, topSumUSD: 0, topSumHK: 0, topSumEUR: 0, //总金额
        botSumCNY: 0, botSumUSD: 0, botSumHK: 0, botSumEUR: 0,//总金额
      },


    }

  },

  created() {
    if (this.$route.query.news == 1) {
      this.activeName = 'first'
    }

  },
  mounted() {
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName;
    }
    //验证调取
    //this.getValidVice();\
    //获取数据
    this.AllGetOrder();

  },
  computed: {
  },
  methods: {
    //选项卡
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    AllGetOrder() {
      //订单信息
      this.OrderInformation();
      //货物信息
      this.ExpOrderGoodsInfo();
      //订单保险信息
      this.ExpOrderInsurance();
      //订单附件信息
      this.ExpOderEnclosure();
      //订单账单信息
      this.getExpBill();
      //获取轨迹信息
      this.ExpOrderTrack();
      //获取附加服务信息
      this.GetExpOrderExtraFee();
      //获取登陆用户名
      this.initfunction();
    },
    //获取订单信息接口
    OrderInformation() {
      let that = this;
      that.api.param = {
      }
      //that.api.url = this.$api03 + "/api/TradeCustomer/ExpNewOrder/GetCustOrder/" + that.$route.query.ord;
      that.api.url = this.$api04 + "/Express/api/ExpNewOrder/GetCustOrder/" + that.$route.query.ord;
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK) {
          that.OrderInfo = res.Results  //所有订单信息
          that.OrderInfo.BaseModeCode = res.Results.BaseModeCode //运输方式大类
          that.WareHouseID = res.Results.WareHouseID;
          //console.log('ss'+JSON.stringify(res));
          //轨迹信息默认展示

          //收货材积
          that.Receivinginfo.ReceCount = res.Results.ReceCount
          that.Receivinginfo.ReceWeight = res.Results.ReceWeight
          that.Receivinginfo.ReceVolume = res.Results.ReceVolume
          that.Receivinginfo.ReceCusVolWeight = res.Results.ReceCusVolWeight
          that.Receivinginfo.ReceCusChargeWeight = res.Results.ReceCusChargeWeight

          that.StatusShow();
          that.getShipAddr();
          that.isShowProBox()
        }
      })
    },
    GetExpOrderExtraFee() {
      let that = this;
      that.api.param = {
        WaybillNO: that.$route.query.ord
      }
      // that.api.url = this.$api03 + "/api/TradeCustomer/ExpOrderExtraFee/Get";
      that.api.url = this.$api04 + "/Express/api/ExpOrderExtraFee/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK && res.Results != null) {
          res.Results.forEach(e => {
            if (e.RelatedService == 0) {
              that.ExpOrderExtraFeeName += e.FeeName + ',';
            } else {
              if (e.RelatedService == 1) {
                that.ExpOrderExtraFeeName += '一般贸易报关服务' + ',';
              }
              if (e.RelatedService == 2) {
                that.ExpOrderExtraFeeName += '关税预付服务' + ',';
              }
              if (e.RelatedService == 3) {
                that.ExpOrderExtraFeeName += '第三方支付关税服务' + ',';
              }
              if (e.FeeSelectType == 2 || e.FeeSelectType == 1) {
                that.ExpOrderExtraFeeName += e.FeeName + ',';
              }
            }
          })
        }
        that.arrayDuplicate(that.ExpOrderExtraFeeName);
      })
    },
    //修改未读信息
    AlreadyRead(name) {
      let that = this;
      that.api.param = {
        orderId: that.$route.query.ord,
        userNames: name + '-CUS',
        readName: name + '-CUS',
      }
      // that.api.url = this.$api03 + "/api/TradeCustomer/OrderOnlineInfo/UpdateReadMsgs";
      that.api.url = this.$api04 + "/Basics/api/IM/UpdateReadMsgs";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK) {
        }
      })
    },

    //获取用户名
    initfunction() {
      let _this = this;
      // this.api.url = this.$api02 + '/api/CustomerInfo/GetCustomerInfoByToken';
      this.api.url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {}
      post(this.api.url, this.api.param)
        .then((res) => {
          if (res.Results != null || res.Results != '') {
            _this.AlreadyRead(res.Results.LoginName);
          }
        })
    },
    //附加服务去重复
    arrayDuplicate(str) {
      let array = str.split(",");
      let hash = [];
      for (var i = 0; i < array.length; i++) {
        if (hash.indexOf(array[i]) == -1) {
          hash.push(array[i]);
        }
      }
      return this.ExpOrderExtraFeeName = hash.join(",");
    },
    //获取轨迹信息
    ExpOrderTrack() {
      let that = this;
      that.api.param = {
        waybillNO: that.$route.query.ord
      }
      // that.api.url = this.$api03 + "/api/TradeCustomer/ExpOrderTrack/Get";
      that.api.url = this.$api04 + "/Express/api/ExpOrderTrack/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK && res.Results != null) {
          //轨迹信息获取
          that.ExpOrderTrackInfo = res.Results;
        }
      })
    },
    //保险信息接口
    ExpOrderInsurance() {
      let that = this;
      that.api.param = {
        waybillNO: that.$route.query.ord
      }
      //that.api.url = this.$api03 + "/api/TradeCustomer/ExpOrderInsurance/Get";
      that.api.url = this.$api04 + "/Express​/api​/ExpOrderInsurance​/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true && res.Results != null) {
          that.OredrInsurance.BuyAmount = res.Results.BuyAmount,
            that.OredrInsurance.Beneficiary = res.Results.Beneficiary,
            that.OredrInsurance.IDCard = res.Results.IDCard,
            that.OredrInsurance.BenefitType = res.Results.BenefitType,
            that.OredrInsurance.IsNeedVoucher = res.Results.IsNeedVoucher
        }
      })
    },

    //是否显示产品信息
    isShowProBox() {  //运输方式为FEDEX、UPS、TNT的订单详情展示产品信息模块
      let obj = 'FEDEX,UPS,TNT'
      this.OrderInfo.BaseModeCode = 'FEDEX'
      if (obj.indexOf(this.OrderInfo.BaseModeCode) > -1) {
        this.getProductInfoApi()
      } else {
        this.ShowProBox = false
      }
    },
    //产品信息接口
    getProductInfoApi() {
      let that = this;
      //that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrderProduct/Get?waybillNO=" + that.$route.query.ord;
      that.api.url = that.$api04 + "/Express/api/ExpOrderProduct/Get?waybillNO=" + that.$route.query.ord;
      fetch(that.api.url).then(function (res) {
        if (res.IsOK && res.Results.length > 0) {
          that.ProductList = res.Results
        }
      })
    },
    //点击产品信息查看明细按钮
    clkProInfos() {
      this.isShowProInfo = !this.isShowProInfo
    },

    //产品信息接口
    getProductInfoApi() {
      let that = this;
      //that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrderProduct/Get?waybillNO=" + that.$route.query.ord;
      that.api.url = that.$api04 + "/Express/api/ExpOrderProduct/Get?waybillNO=" + that.$route.query.ord;
      fetch(that.api.url).then(function (res) {
        if (res.IsOK && res.Results.length > 0) {
          that.ProductList = res.Results
        }
      })
    },
    //货物信息接口
    ExpOrderGoodsInfo() {
      let that = this;
      that.api.param = {
        waybillNO: that.$route.query.ord
      }
      //that.api.url = this.$api03 + "/api/TradeCustomer/ExpOrder/QueryExpOrderReceVolume";
      that.api.url = this.$api04 + "/Express/api/ExpOrder/QueryExpOrderReceVolume";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.OrderGoodsInfo = res.Results  //订单收货材积信息
          if (res.Results) {
            that.IsWarehouse = false
          }
          //console.log('ss'+JSON.stringify(res));
        }
      })
    },
    //仓库地址接口
    getShipAddr() {
      let that = this;
      that.api.url = that.$api04 + "/Air/api/SupplierWarehouse/GetWarhouseByID?id=" + that.WareHouseID;
      fetch(that.api.url).then(function (res) {
        if (res.IsOK == true) {
          //console.log(res)
          that.shipAddress = res.Results.ProvinceName + res.Results.CityName + res.Results.CityAreaName + res.Results.WareAddress;
          that.recipient = res.Results.PersonCharge;
          that.phoneNum = res.Results.PersonPhone;
          that.WarehouseName = res.Results.WareAutoCodeEn;
          that.WareShortCode = res.Results.WareShortCode;
        }
      })
    },
    //获取订单账单信息
    getExpBill() {
      let that = this;
      that.OrderBillInfo = [];
      that.OrderBillInfoBalan = [];
      that.api.param = {
        waybillNO: that.$route.query.ord
      }
      // that.api.url = that.$api03 + "/api/TradeCustomer/ExpBill/QueryExpCusFeeBill";
      that.api.url = that.$api04 + "/Express/api/ExpBill/QueryExpCusFeeBill";
      fetch(that.api.url, that.api.param).then((res) => {
        if (res.IsOK == true && res.Results != null) {
          res.Results.forEach((item) => {
            if ((item.AuditStatus == 100 || item.AuditStatus == 200) && item.BalanceFlag == 0) {
              if (item.Direction) {
                item.Amount = -item.Amount;
                item.ConvertAmount = -item.ConvertAmount;
              }
              that.OrderBillInfo.push(item)
            }
          })
          // Balance账单的一列
          res.Results.forEach((info) => {
            if ((info.AuditStatus == 100 || info.AuditStatus == 200) && info.BalanceFlag == 1) {
              if (info.Direction) {
                info.Amount = -info.Amount;
                info.ConvertAmount = -info.ConvertAmount;
              }
              that.OrderBillInfoBalan.push(info)
            }
          })
          this.Bill.topShow = this.OrderBillInfo,
            this.Bill.botShow = this.OrderBillInfoBalan,
            this.handleBill(this.Bill.topShow, "top")
          this.handleBill(this.Bill.botShow, "bottom")
        }
      })
    },
    /**
     * 处理费用显示
     * @param {Array} data 处理的数组
     * @param {String} flag 判断位置 
     */
    handleBill(data, flag) {
      // 都要对应位置  1 为 RMB 2 USD 3 HK 4EUR
      let index = ['isHaveRMB', 'isHaveUSD', 'isHaveHK', 'isHaveEUR'] //币种索引
      let UnpayIndex = ['topUnpayCny', 'topUnpayUSD', 'topUnpayHK', 'topUnpayEUR'] //上方未支付币种统计索引
      let sumIndex = ['topSumCNY', 'topSumUSD', 'topSumHK', 'topSumEUR'] //总计币种统计索引
      if (flag === 'bottom') {
        sumIndex = ['botSumCNY', 'botSumUSD', 'botSumHK', 'botSumEUR'] //总计币种统计索引
        UnpayIndex = ['botUnpayCny', 'botUnpayUSD', 'botUnpayHK', 'botUnpayEUR'] //未支付币种统计索引
      }
      data.forEach(e => {
        // 用于显示的总金额
        if (e.Currency == 1) {
          e.allAmout = e.Amount
        } else {
          e.allAmout = e.ConvertAmount
        }
        //  BillStatus 1 ==>已完成 
        if (e.BillStatus == 1) {
          e.UnpayAmount = e.CreditAmount - e.PayCreditAmount
        } else {
          e.UnpayAmount = e.allAmout - e.AccountAmount - e.PayCreditAmount
        }
        //统计加和未支付 状态已完成的也有未支付
        this.Bill[UnpayIndex[e.Currency - 1]] += Number(e.UnpayAmount)
        this.Bill[sumIndex[e.Currency - 1]] += Number(e.allAmout)
        this.Bill[index[e.Currency - 1]] = true //是否显示该币种
      });
    },
    InsideBatteryName(code) {
      if (code == 10)
        return 'Built-in lithium ion batteries'
      if (code == 11)
        return 'Built-in lithium metal batteries'
    },
    MatingBatteryName(code) {
      if (code == 17)
        return 'Dry batteries packed with equipment'
      if (code == 18)
        return 'Lithium ion batteries packed with equipment'
      if (code == 19)
        return 'Lithium metal batteries packed with equipment'
    },
    //订单附件信息
    ExpOderEnclosure() {
      let that = this;
      that.api.param = {
        waybillNO: that.$route.query.ord
      }
      //that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrderUploadFiles/Get";
      that.api.url = that.$api04 + "/Express/api/ExpOrderUploadFiles/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.OrderEnclosure = res.Results  //订单附件信息
          //console.log('ss'+JSON.stringify(res));

        }
      })
    },
    //下载附件信息
    DownloadAttachments(id, name) {
      let url = id
      //console.log(url)
      // downloadFile(url, name)
      // window.location.href = url
      fileSteamDownload(this, {
        FullPath: url, // 路径
        CurrentFileName: name // 文件名称
      }, name)
      // this.downloadFileYun(url, name)
    },
    // downloadFileYun(urlFire, fileName) {
    //   let params = {
    //     FullPath: urlFire,
    //     CurrentFileName: fileName
    //   }
    //   let url = this.$api04 + '/File/api/FileHandle/Download'
    //   fetch(url, params).then((res) => {
    //     console.log(5644655);
    //   })
    // },
    //打开货物详情
    SelectDetailed() {
      if (this.IsOrderEnclosure) {
        this.IsOrderEnclosure = false;
      } else {
        this.ExpOrderGoodsInfo();
        this.IsOrderEnclosure = true;
      }
    },
    //打开仓库信息
    Warehouse() {
      if (this.IsWarehouse) {
        this.IsWarehouse = false;
      } else {
        this.IsWarehouse = true;
      }
    },
    //打开起运地信息
    OpenDeparture() {
      if (!this.IsDeparture && this.OrderInfo.DeliveryType == 3) {
        this.IsDeparture = true;
        this.IsWareHouse = false;
        this.IsDestination = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.5.png';
        }

      } else if (!this.IsDeparture2 && (this.OrderInfo.DeliveryType == 0 || this.OrderInfo.DeliveryType == 1 || this.OrderInfo.DeliveryType == 2)) {
        this.IsDeparture2 = true;
        this.IsWareHouse = false;
        this.IsDestination = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory0.5.png';
        }

      } else if (this.IsDeparture && this.OrderInfo.DeliveryType == 3) {
        this.IsDeparture = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }
      }
      else if (this.IsDeparture2 && (this.OrderInfo.DeliveryType == 0 || this.OrderInfo.DeliveryType == 1 || this.OrderInfo.DeliveryType == 2)) {
        this.IsDeparture2 = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }
      }


    },
    //打开仓库信息
    OpenWarehouse() {
      if (this.IsWareHouse) {
        this.IsWareHouse = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }
      } else {
        this.IsWareHouse = true;
        this.IsDeparture = false;
        this.IsDeparture2 = false;
        this.IsDestination = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory2.5.png';
        }
      }
    },
    //打开目的地信息
    OpenDestination() {

      if (this.IsDestination) {
        this.IsDestination = false;


      } else {
        this.IsDestination = true;
        this.IsWareHouse = false;
        this.IsDeparture = false;
        this.IsDeparture2 = false;
        if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.1.png'
        }
        if (this.OrderInfo.Status == 1) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.2.png'
        }
        if (this.OrderInfo.Status == 2) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.3.png'
        }
        if (this.OrderInfo.Status == 3) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.4.png';
        }
        if (this.OrderInfo.Status == 4) {
          this.TrajectoryUrl = '../../../../static/img/Trajectory1.5.png';
        }


      }
    },
    //参考号修改
    CustomerIDUpdate(id) {
      if (this.IsCustomerID) {
        this.IsCustomerID = false;
      } else {
        this.IsCustomerID = true;
        this.CustomerIDUp = id;
      }
    },
    //参考号Api
    SaveRefNOApi(id) {
      let that = this;
      that.api.param = {
        WaybillNO: id,
        RefNO: that.CustomerIDUp
      }
      //that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrder/UpdateRefNO";
      that.api.url = that.$api04 + "/Express/api/ExpOrder/UpdateRefNO";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.AllGetOrder();
          that.IsCustomerID = false;
        }
      })
    },
    //保存参考号
    UpdataRefNO(id) {
      if (this.checkRefNo()) {
        return false
      }
      this.$confirm("Do you save the reference number?", "", {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        //showCancelButton: false, //去掉取消按钮
        //showClose: false, //去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.IsrefNo = false;
        this.SaveRefNOApi(id);
      }).catch(() => { });
      return false;

    },
    //时间格式转换
    BillStatusName(id) {
      if (id == 0) return 'Unfinished';
      if (id == 1) return 'Finished';
      if (id == 2) return 'Unfinished';
    },
    ExportBill() {
      let that = this;
      that.api.param = {
        WaybillNO: that.OrderInfo.Id
      }
      // that.api.url = that.$api03 + "/api/TradeCustomer/ExpOrder/BillCostReportQuery";
      that.api.url = that.$api04 + "/Express/api/ExpOrder/BillCostReportQuery";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          let Name = 'Billing_' + that.$route.query.ord + '_' + new Date().Format('yyyyMMdd') + '.pdf'
          let url = res.Results
          // downloadFile(url, Name)
          // window.location.href = url
          fileSteamDownload(that, {
            FullPath: url, // 路径
            CurrentFileName: Name // 文件名称
          }, Name)
        } else {
          that.$alert('Export failure', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confrim',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            center: true
          }).then(() => {
          }).catch(() => {
          });
        }
      })
    },
    //取消保存参考号
    cancel() {
      this.IsCustomerID = false;
      this.IsrefNo = false
    },
    checkRefNo() {
      if (this.CustomerIDUp == '' || this.CustomerIDUp == null) {
        this.IsrefNo = true;
        return true;
      } else {
        this.IsrefNo = false;
        return false;
      }

    },
    //获取订单状态名称
    StatusName(code) {
      if (code == "0") return "Confirming";
      if (code == "1") return "Receiving";
      if (code == "2") return "Received";
      if (code == "3") return "Delivered";
      if (code == "4") return "Completed";
      if (code == "5") return "Returned";
      if (code == "6") return "Canceled";
    },
    SrcFrom(id) {
      var imtoken = $.cookie('IMEn-TOKEN');
      return this.$apiIMEn + 'chats/Worklist?orderid=' + id + '&trackid=' + imtoken + '&lan=English';
    },
    //轨迹显示状态
    StatusShow() {
      if (this.OrderInfo.Status == 0 || this.OrderInfo.Status == 6 || this.OrderInfo.Status == 5) {
        this.IsDeparture2 = true;
        this.IsDestinationxl = false;

        this.TrajectoryUrl = '../../../static/img/Trajectory08.png';
        //默认展开第一段，仅显示下单时间；第二段默认不展开；第三段不提供展开收起图标。
      }
      if (this.OrderInfo.Status == 1 && this.OrderInfo.DeliveryType == 0) {
        this.IsDeparture2 = true;
        //点亮第一段和货车连接线；默认展开第一段；第二段默认不展开，第三段默认不展开
        this.TrajectoryUrl = '../../../static/img/Trajectory03.png';
      }
      if (this.OrderInfo.Status == 1 && (this.OrderInfo.DeliveryType == 2 || this.OrderInfo.DeliveryType == 3)) {
        this.IsDeparture = true;
        this.TrajectoryUrl = '../../../../static/img/Trajectory03.png';
        //点亮第一段和货车连接线；默认展开第一段；第二段默认不展开，第三段默认不展开
      }
      if (this.OrderInfo.Status == 2) {
        this.IsWareHouse = true;
        this.TrajectoryUrl = '../../../../static/img/Trajectory07.png';
        //点亮起始城市、货车连接路线、收货仓库；第一段默认不展开，默认展开第二段，第三段默认不展开
      }
      if (this.OrderInfo.Status == 3) {
        this.IsDestination = true;
        this.TrajectoryUrl = '../../../../static/img/Trajectory09.png';
        //点亮起始城市、货车连接路线、收货仓库、飞机连接路线；第一段和第二段默认不展开，默认展开第三段。其中，订单承运商的轨迹，最新的一条用蓝色圆圈标识。
      }
      if (this.OrderInfo.Status == 4) {
        this.IsDestination = true;
        //全部点亮；第一段和第二段默认不展开，默认展开第三段
        this.TrajectoryUrl = '../../../../static/img/Trajectory10.png';
      }
    },
    AmountNameGet(id) {
      if (id == 1) return '￥';
      if (id == 2) return 'US $';
      if (id == 3) return 'HK $';
      if (id == 4) return '€';
    },
    //包裹类型名称
    PackageTypeName(id) {
      if (id == 1) return 'Package';
      if (id == 2) return 'Docs';
    },
    ShareOrder() {
      this.$refs.shareOrder.clkDialog(this.OrderInfo.Id);
    },

  }
}



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/exp/expDetails.js